export default "__VITE_ASSET__B8JEf71z__"